'use strict';

const utils = module.exports;
const _ = require('lodash');

utils.reset = function (base, apply) {
    let key;
    for (key in base) {
        if (base.hasOwnProperty(key) && !apply.hasOwnProperty(key)) {
            delete base[key];
        }
    }

    utils.set(base, apply);
};

utils.set = function (base, apply) {
    let key;
    for (key in apply) {
        if (apply.hasOwnProperty(key)) {
            base[key] = apply[key];
        }
    }
};

utils.diff = function (base, apply) {
    const diff = {};

    let key;
    for (key in base) {
        if (base.hasOwnProperty(key) && !apply.hasOwnProperty(key)) {
            diff[key] = undefined;
        }
    }

    for (key in apply) {
        if (apply.hasOwnProperty(key) && !_.isEqual(base[key], apply[key])) {
            diff[key] = apply[key];
        }
    }

    return diff;
};

utils.ownProperties = function (obj) {
    const result = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            result[key] = obj[key];
        }
    }

    return result;
};
